

import React, { useState } from "react";
import { Table, Card, CardHeader, CardBody, Row, Col, CardTitle, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader";
import { Calendar } from 'react-date-range';

export default function MultiPlayerAnalyticsTable() {
    const { token } = useToken()
    const { timeZone } = useTimeZone()
    const [allPlayerAnalytics, setAllPlayerAnalytics] = useState()
    const [allPlayerAnalyticsOrg, setAllPlayerAnalyticsOrg] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [isShowStartDateModal, setIsShowStartDateModal] = useState(false)
    const [isShowEndDateModal, setIsShowEndDateModal] = useState(false)
    const dateDefault = new Date();
    const [dateRangeState, setDateRangeState] = useState({
        "startDate": new Date(dateDefault.getFullYear(), dateDefault.getMonth(), 1),
        "endDate": new Date(dateDefault.getFullYear(), dateDefault.getMonth() + 1, 0),
    });
    const [sortableColumns, setSortableColumns] = useState({ "minsTotal": "decs" })
    var differenceInTime = dateDefault.getTime() - dateRangeState.startDate.getTime()
    const [totalDays, setTotalDays] = useState(parseInt(differenceInTime / (1000 * 3600 * 24)) + 1)

    const loadData = () => {
        setIsLoading(true)
        console.log('MultiPlayerAnalyticsTable: get data')
        const myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);

        const requestOptions = {
            method: 'GET',
            headers: myHeaders
        };

        const params = new URLSearchParams({
            'timezone_offset_minutes': timeZone * -60,
            'start_date': dateRangeState.startDate.toLocaleDateString("en-US", {
                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
            }),
            'end_date': dateRangeState.endDate.toLocaleDateString("en-US", {
                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
            })
        });

        fetch(process.env.REACT_APP_BASE_URL + "analytics/player?" + params, requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    // console.log(json)
                    if (result.ok) {

                        var allAnalytics = []

                        for (const player_analytics_id in json.data) {
                            const analytics = json.data[player_analytics_id]
                            if ((analytics.seconds_mini > 60) || (analytics.seconds_large > 60)) {
                                allAnalytics.push(analytics)
                            }
                        }

                        setAllPlayerAnalyticsOrg(allAnalytics)

                        allAnalytics.sort((a, b) => {
                            if (a["seconds_mini"] + a["seconds_large"] < b["seconds_mini"] + b["seconds_large"]) {
                                return 1
                            } else {
                                return -1
                            }
                        })

                        setAllPlayerAnalytics(allAnalytics.slice(0, 20))
                    }
                    else {
                        // console.log(result.json.message)

                    }
                    setIsLoading(false)
                }
            )
    }

    const exportAnalyticsPlayerCsv = () => {
        console.log('exportAnalyticsPlayerCsv')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
        }

        const params = new URLSearchParams({
            'timezone_offset_minutes': timeZone * -60,
            'start_date': dateRangeState.startDate.toLocaleDateString("en-US", {
                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
            }),
            'end_date': dateRangeState.endDate.toLocaleDateString("en-US", {
                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
            })
        });

        fetch(process.env.REACT_APP_BASE_URL + "analytics/player/export_csv?" + params, requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.blob()
                    .then((blob) => resolve({
                        status: response.status,
                        ok: response.ok,
                        blob,
                    })))
            }).then(
                async (result) => {
                    var blob = result.blob
                    if (result.ok) {
                        setIsLoading(false)
                        var file = window.URL.createObjectURL(blob, 'csv');
                        // window.location.assign(file);
                        var anchor = document.createElement("a");
                        anchor.download = "mins_report.csv";
                        anchor.href = file;
                        anchor.click();
                    }
                    else {
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            ).catch(function () {
                console.log("error");
                setIsLoading(false)
            });
    }

    function sortPlayerAnalyticsTable(sortableField) {
        console.log(sortableField)
        var sortValue = "decs"
        if (sortableColumns[sortableField] === "decs") {
            sortValue = "acs"
        }

        var sortData = [...allPlayerAnalyticsOrg]
        sortData.sort((a, b) => {
            var leftValue = a["seconds_mini"]
            var rightValue = b["seconds_mini"]

            if (sortableField === "minsTotal" || sortableField === "minsTotalAVG") {
                leftValue += a["seconds_large"]
                rightValue += b["seconds_large"]
            } else if (sortableField === "minsLarge") {
                leftValue = a["seconds_large"]
                rightValue = b["seconds_large"]
            }

            if (leftValue > rightValue) {
                return sortValue === "acs" ? 1 : -1
            } else {
                return sortValue === "acs" ? -1 : 1
            }
        })

        setAllPlayerAnalytics(sortData.slice(0, 20))

        setSortableColumns({
            [sortableField]: sortValue
        })
    }


    return (

        <TMHLoader active={isLoading}>
            <Modal isOpen={isShowStartDateModal}>
                <ModalHeader tag="h2" className="mx-auto">Select Start Date</ModalHeader>
                <ModalBody>
                    <Calendar className="ml-5" onChange={item => {
                        setDateRangeState({ ...dateRangeState, "startDate": item })
                        differenceInTime = dateRangeState.endDate.getTime() - item.getTime()
                        setTotalDays(parseInt(differenceInTime / (1000 * 3600 * 24)) + 1)
                        setIsShowStartDateModal(false)
                    }
                    }
                        date={dateRangeState.startDate} />
                </ModalBody>
                <ModalFooter>
                    <Button className="text-center mx-auto mb-4" onClick={() => setIsShowStartDateModal(false)} color="danger">Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isShowEndDateModal}>
                <ModalHeader tag="h2" className="mx-auto">Select End Date</ModalHeader>
                <ModalBody>
                    <Calendar className="ml-5" onChange={item => {
                        setDateRangeState({ ...dateRangeState, "endDate": item })
                        differenceInTime = item.getTime() - dateRangeState.startDate.getTime()
                        if (item > dateDefault) {
                            differenceInTime = dateDefault.getTime() - dateRangeState.startDate.getTime()
                        }
                        setTotalDays(parseInt(differenceInTime / (1000 * 3600 * 24)) + 1)
                        setIsShowEndDateModal(false)
                    }
                    }
                        date={dateRangeState.endDate} />
                </ModalBody>
                <ModalFooter>
                    <Button className="text-center mx-auto mb-4" onClick={() => setIsShowEndDateModal(false)} color="danger">Cancel</Button>
                </ModalFooter>
            </Modal>

            <Card>
                <CardHeader>
                    <CardTitle className="text-left" tag="h2">
                        <Row>
                            <Col md="4">
                                Users by ID and mins report
                            </Col>
                            <Col md="4" tag="h4" className="mt-2">
                                From: <Button className="btn-simple" color="warning" size="sm" onClick={() => { setIsShowStartDateModal(true) }}>
                                    {dateRangeState.startDate.toLocaleDateString("en-US", {
                                        weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
                                    })}
                                </Button> {" "}
                                To: <Button className="btn-simple" color="warning" size="sm" onClick={() => { setIsShowEndDateModal(true) }}>
                                    {dateRangeState.endDate.toLocaleDateString("en-US", {
                                        weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
                                    })} </Button>
                            </Col>
                            <Col md="2" tag="h4" className="mt-2">
                                Export {" "}
                                <Button onClick={() => exportAnalyticsPlayerCsv()} className="btn-icon btn-simple" color="success" size="sm">
                                    <i className="fa-solid fa-file-export" />
                                </Button>
                            </Col>
                            <Col md="2" tag="h4" className="mt-2">
                                Reload Data {" "}
                                <Button onClick={() => loadData()} className="btn-icon btn-simple" color="success" size="sm">
                                    <i className="fa fa-refresh" />
                                </Button>
                            </Col>
                        </Row>
                    </CardTitle>
                </CardHeader>
                <CardBody>

                    <Row>
                        <Col>
                            <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Device ID</th>
                                        <th>Device</th>
                                        <th>Av watch time per day {""}
                                            <Button
                                                className="btn-icon btn-simple"
                                                color={sortableColumns["minsTotalAVG"] ? "success" : "default"}
                                                size="sm"
                                                onClick={() => sortPlayerAnalyticsTable("minsTotalAVG")}
                                            >
                                                {
                                                    sortableColumns["minsTotalAVG"] === "decs" ?
                                                        <i className="fas fa-sort-amount-up-alt"></i> :
                                                        sortableColumns["minsTotalAVG"] === "acs" ?
                                                            <i className="fas fa-sort-amount-down-alt"></i> :
                                                            <i className="fas fa-sort"></i>
                                                }
                                            </Button></th>
                                        <th>Mins (mini) {""}
                                            <Button
                                                className="btn-icon btn-simple"
                                                color={sortableColumns["minsMini"] ? "success" : "default"}
                                                size="sm"
                                                onClick={() => sortPlayerAnalyticsTable("minsMini")}
                                            >
                                                {
                                                    sortableColumns["minsMini"] === "decs" ?
                                                        <i className="fas fa-sort-amount-up-alt"></i> :
                                                        sortableColumns["minsMini"] === "acs" ?
                                                            <i className="fas fa-sort-amount-down-alt"></i> :
                                                            <i className="fas fa-sort"></i>
                                                }
                                            </Button>
                                        </th>
                                        <th>Mins (large) {""}
                                            <Button
                                                className="btn-icon btn-simple"
                                                color={sortableColumns["minsLarge"] ? "success" : "default"}
                                                size="sm"
                                                onClick={() => sortPlayerAnalyticsTable("minsLarge")}
                                            >
                                                {
                                                    sortableColumns["minsLarge"] === "decs" ?
                                                        <i className="fas fa-sort-amount-up-alt"></i> :
                                                        sortableColumns["minsLarge"] === "acs" ?
                                                            <i className="fas fa-sort-amount-down-alt"></i> :
                                                            <i className="fas fa-sort"></i>
                                                }
                                            </Button>
                                        </th>
                                        <th>Mins (total) {""}
                                            <Button
                                                className="btn-icon btn-simple"
                                                color={sortableColumns["minsTotal"] ? "success" : "default"}
                                                size="sm"
                                                onClick={() => sortPlayerAnalyticsTable("minsTotal")}
                                            >
                                                {
                                                    sortableColumns["minsTotal"] === "decs" ?
                                                        <i className="fas fa-sort-amount-up-alt"></i> :
                                                        sortableColumns["minsTotal"] === "acs" ?
                                                            <i className="fas fa-sort-amount-down-alt"></i> :
                                                            <i className="fas fa-sort"></i>
                                                }
                                            </Button>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        allPlayerAnalytics && allPlayerAnalytics.map((playerInfo, player_analytics_id) => {
                                            return (<tr key={player_analytics_id}>
                                                <td>{playerInfo.device_id.split("-")[0]}</td>
                                                <td>{playerInfo.device_name}</td>
                                                <td>{parseInt((playerInfo.seconds_mini + playerInfo.seconds_large) / 60 / totalDays)}</td>
                                                <td>{parseInt(playerInfo.seconds_mini / 60)}</td>
                                                <td>{parseInt(playerInfo.seconds_large / 60)}</td>
                                                <td>{parseInt((playerInfo.seconds_mini + playerInfo.seconds_large) / 60)}</td>
                                            </tr>)
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </TMHLoader>
    );
}